import { SiteDetailsResponseModel } from "@models/site";
import { Link } from "gatsby";
import React from "react";
import UnbxdLogoText from "@assets/images/svg/unbxd_logo_text.svg";
import UnbxdLogoLightText from "@assets/images/svg/unbxd_light_2.svg";
import NavItem from "./NavItem";
import { twMerge } from "tailwind-merge";
import { loginBtnClassBasedOnTheme, navThemeBasedClass } from "@utils/constant";
import NewLink from "../NewLink";

export interface NavBarPropsModel {
  navigation: SiteDetailsResponseModel["navigation"];
  showBanner: boolean;
  darkTheme: boolean;
}

const NavBar: React.FunctionComponent<NavBarPropsModel> = ({
  navigation,
  darkTheme,
  showBanner,
}) => {
  const { items } = navigation ?? {};
  const { data: mainHeaderDataObjects } = items ?? {};
  const navTheme = darkTheme ? "dark" : "light";
  const navClass = navThemeBasedClass?.[navTheme];
  const loginBtnClass = loginBtnClassBasedOnTheme?.[navTheme] ?? "";

  const renderLogo = () => (
    <div className="overflow-hidden h-8 w-[140px]">
      <Link to="/">
        {darkTheme ? <UnbxdLogoText /> : <UnbxdLogoLightText />}
      </Link>
    </div>
  );

  return (
    <nav
      className={twMerge(
        "h-[70px] px-4 xl:px-8 2xl:px-20 3xl:px-[120px] flex items-center justify-between overflow-y-scroll",
        navClass
      )}
    >
      <div className="flex items-center">
        <div>{renderLogo()}</div>
        <ul className="flex gap-4 xl:gap-4 2xl:gap-6 3xl:gap-8 h-[70px] pl-4 xl:pl-8 2xl:pl-16 3xl:pl-[74px]">
          {mainHeaderDataObjects?.map((oneMainHeaderDataObject) => {
            const { attributes } = oneMainHeaderDataObject ?? {};
            return (
              <NavItem
                navAttributes={attributes}
                key={oneMainHeaderDataObject.id}
                showBanner={showBanner}
              />
            );
          })}
        </ul>
      </div>
      <div className="flex gap-4 mx-0">
        <NewLink
          href="https://console.unbxd.io"
          className={loginBtnClass}
          variant="secondaryReversed"
          target="_blank"
          style={{
            textDecoration: "none",
            height: "43px",
          }}
        >
          LOGIN
        </NewLink>
        {/* <Button
          variant="secondaryReversed"
          className={loginBtnClass}
          style={{
            height: "43px",
            padding: 0,
          }}
        >
          <a
            href="https://console.unbxd.io"
            referrerPolicy="no-referrer"
            target="_blank"
            className={loginBtnClass}
            style={{
              height: "43px",
              display: "block",
            }}
          >
            LOG IN
          </a>
        </Button> */}
        <NewLink
          style={{
            height: "43px",
            textTransform: "uppercase",
          }}
          href="/demo"
        >
          find a new way to search
        </NewLink>
      </div>
    </nav>
  );
};
export default NavBar;
